// Wraps html2canvas + JPEG compression for the QA overlay.
// Dynamically imports html2canvas so it's only loaded when needed.

export const MAX_SCREENSHOT_BYTES = 500 * 1024
const QUALITY_STEPS = [0.8, 0.7, 0.6, 0.5, 0.4, 0.3]

function decodedBytes(base64) {
  const body = base64.includes(',') ? base64.split(',')[1] : base64
  return Math.floor(body.length * 0.75)
}

function extractBody(dataUrl) {
  return dataUrl.includes(',') ? dataUrl.split(',')[1] : dataUrl
}

export async function captureViewport() {
  let html2canvas
  try {
    const mod = await import('html2canvas')
    html2canvas = mod.default
  } catch (err) {
    return { ok: false, error: 'Failed to load screenshot library' }
  }

  let canvas
  try {
    canvas = await html2canvas(document.body, {
      scale: 1,
      useCORS: true,
      logging: false,
      backgroundColor: null,
    })
  } catch (err) {
    return { ok: false, error: 'Screenshot capture failed: ' + (err?.message || 'unknown') }
  }

  for (const quality of QUALITY_STEPS) {
    const dataUrl = canvas.toDataURL('image/jpeg', quality)
    const body = extractBody(dataUrl)
    const bytes = decodedBytes(body)
    if (bytes <= MAX_SCREENSHOT_BYTES) {
      return { ok: true, b64: body, sizeKb: Math.round(bytes / 1024), quality }
    }
  }

  return {
    ok: false,
    error: 'Screenshot too large — try a smaller viewport or skip the screenshot',
  }
}
